module.exports = __webpack_public_path__ + "img/a13.c42944cc.svg";